import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import { Col, Row } from 'react-bootstrap-5';
import { createNote } from '../../../helpers/prospect_api';
import TrixEditor from 'components/ui/trix/trix_editor';
import type { Note } from 'bundles/connect/types';

type Props = {
  recordId: number;
  recordType: string;
  show: boolean;
  onCreate: (note: Note) => void;
  onHide: () => void;
  callListId?: number;
}

export default function NewNoteForm({ recordId, recordType, show, onCreate, onHide, callListId }: Props) {
  const [body, setBody] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = () => {
    createNote(body, recordId, recordType, undefined, callListId)
      .then((note) => {
        onCreate(note);
        onHide();
        setBody('');
      })
      .finally(() => setSaving(false));
  };

  if (!show) return null;

  return (
    <div className="d-flex flex-column gap-2">
      <div className="privacy-mask">
        <TrixEditor id="new-note" name="body" onChange={setBody} />
      </div>
      <Row className="justify-content-end">
        <Col xs="auto">
          <Button disabled={saving} label="Cancel" variant="ghost" onClick={onHide} />
        </Col>
        <Col xs="auto">
          <Button disabled={saving} label="Save" variant="secondary" onClick={handleSave} />
        </Col>
      </Row>
    </div>
  );
}
